<app-homepage-header pageName="Shipping Method"></app-homepage-header>
<div class="shipping-method-container">
  <div class="shipping-container">
    <div class="shipping-method-payment-container w-100">
      <div class="shipping-method-slash-text-container">
        <div class="shipping-method-cart-text">{{ 'shipping-address.cart' | translate }}</div>
        <div class="shipping-method-slash-text">/</div>
        <div class="shipping-method-text">{{ 'shipping-address.shipping' | translate }}</div>
      </div>
      <br>
      <div class="shipping-to-and-delivery-container">
        @if (deliveryAddress && selectedDeliveryMethod !== ShippingType.PICKUP) {
          <div class="ship-to-container">
            <div class="ship-to-text-container">
              <div class="ship-to-text">{{ 'shipping-method.ship_to' | translate }}</div>
              <div class="ship-to-address">{{ truncateText(deliveryAddress, 40)}}</div>
            </div>
            <button class="text-button tall-button" (click)="navigateToShippingAddress()">{{ 'shipping-method.change' | translate }}</button>
          </div>
          <br>
        }
        <div class="shipping-method-delivery-container">
          <div class="shipping-method-title">{{ 'shipping-method.shipping_method' | translate }}</div>
          <br>
          <app-delivery-select
            [deliverySelect]="deliverySelectStandard"
            (radioSelected)="selectDeliveryMethod(ShippingType.STANDARD)">
          </app-delivery-select>
          <br>
          <app-delivery-select
            [deliverySelect]="deliverySelectExpress"
            (radioSelected)="selectDeliveryMethod(ShippingType.EXPRESS)">
          </app-delivery-select>
          <br>
          <app-delivery-select
            [deliverySelect]="deliverySelectPickup"
            (radioSelected)="selectDeliveryMethod(ShippingType.PICKUP)">
          </app-delivery-select>
        </div>
        <br>
        <br>
        <div class="buttons-container d-flex align-items-center">
          <button class="shipping-method-non-button" (click)="returnToCart()">{{ 'shipping-method.return' | translate }}</button>
          <button class="shipping-method-button" (click)="continueToNextStep()">{{ 'shipping-method.continue' | translate }}</button>
        </div>
      </div>
    </div>
    <app-order-summary [allCarts]="products" [totalSumAmd]="totalSumAmd" [totalSumUsd]="totalSumUsd" class="w-100 mt-50px right-orders-part"></app-order-summary>
  </div>
</div>
<app-footer></app-footer>
